<template>
  <div class='h100vh-60'>
    <TsCommonMenu ref='tsMenuButton' :searchBtn='true' :exportBtn='true' @methodEnum='methodEnum' ></TsCommonMenu>
    <div class="h100-80">
      <TsCommonTable ref='tsTable' :tsUrl= tsUrl :tableColumns='tableColumns'></TsCommonTable>
    </div>
    <CustomDialog ref='searchDialog' :element='searchDialogSetting.element' :styles='searchDialogSetting.styles' :messages='searchDialogSetting.messages'>
      <template v-slot:dialog-content>
        <QueryCondition ref="query"></QueryCondition>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import CustomDialog from '../../../common/CustomDialog';
import TsCommonMenu from '../TsCommonMenu';
import QueryCondition from '../QueryConditionDialog';
import TsCommonTable from '../TsCommonTable';
import { EventBus } from '../../../../plugins/eventBus';
import Global from '../../Global';
export default {
  name: 'CallTimeSingleList',
  components: {
    CustomDialog,
    TsCommonMenu,
    TsCommonTable,
    QueryCondition
  },
  data() {
    return {
      olapUrl: Global.olapUrl,
      queryConditions: {},
      searchDialogSetting: {
        styles: {
          width: '860px',
          height: '717px',
          model: true,
          visible: false
        },
        element: {
          target: '#app',
          refName: 'search',
          title: this.$t('Track.createTask'),
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Track.cancel') } },
            { click: this.queryConfirm, buttonModel: { content: this.$t('Track.confirm'), isPrimary: true } }
          ]
        },
        messages: {
          title: this.$t('TS.gs_search')
        }
      },
      tsUrl: '',
      tableColumns: [
        { field:'name', headerText: this.$t("Track.taskStatus"), textAlign:'Center', clipMode:'EllipsisWithTooltip' },
        { field:'taskStatus', headerText: this.$t("Track.taskStatus"), textAlign:'Center', clipMode:'EllipsisWithTooltip', disableHtmlEncode: false,
          formatter: (grids, data)=> {
            const { taskStatus } = data;
            switch (taskStatus) {
              case 1:
                return `<span style='color:blue;'>${this.$t('Track.issued')}</span>`;
              case 2:
                return `<span style='color:blue;'>${this.$t('Track.greate')}</span>`;
              default:
                return taskStatus;
            }
          }
        }
      ]
    };
  },
  methods: {
    statusFormat(grids, data) {
      const { taskStatus } = data;
      switch (taskStatus) {
        case 1:
          return `<span style='color:blue;'>${this.$t('Track.issued')}</span>`;
        case 2:
          return `<span style='color:blue;'>${this.$t('Track.greate')}</span>`;
        default:
          return taskStatus;
      }
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.searchDialog.show();
          break;
        case 'import':
          this.$refs.tsTable.exportData();
          break;
        default:
      }
    },
    dialogHide() {
      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
    },
    queryConfirm(params) {
      // $this.queryConditions = $this.$refs.query.getQueryCondition();
      // console.log($this.searchConditions);
      // if ($this.searchConditions) {
      //   const url = `${This.olapUrl}/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
      //   // const url = `/olap/lte/ems/olap/voice/getAllCountAndFailCount.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
      //   $this.$loading.showLoadding($this.$t('MML.loadingTip'));
      //   $this.$axios.get(url).then((response) => {
      //     if (response && response.status === 200) {
      //
      //     }
      //     $this.dialogHide();
      //     $this.$loading.hideLoadding();
      //   }).catch(err => {
      //     $this.$loading.hideLoadding();
      //   });
      // }
    },
  }
};

</script>

<style scoped>

</style>
